module.exports = __webpack_public_path__ + "img/block-purple.5c7fd2b1.png";